// import { updatePayment } from '../actions/shopping-cart';
// import _ from 'lodash';
import { ADD_TO_CART, DELETE_FROM_CART, REMOVE_FROM_CART, UPDATE_CART, CHECK_PROMOTION, CHECK_PROMOTION_ERR, ADD_PROMO_CODE, CREATE_ORDER, CREATE_ORDER_CHAT, UPDATE_PAYMENT, PAY_CREDITCARD, CHANGE_QTY, CART_PROCESS, UPDATE_PAYMENT_ERR, GET_ORDER_RESPONSE, GET_ORDER_RESPONSE_ERR, GET_CART, GET_PRO_ERR, CLEAR_COUPON_CODE, DISPLAY_FREE_ITEM_POPUP, ADD_TO_BLOGGER_CART, CHANGE_BLOGGER_CART_QTY, DELETE_FROM_BLOGGER_CART, CLEAR_COUPON_ERR_MSG } from '../actions/shopping-cart/type';
import { GET_QR, GET_CHARGE_STATUS } from '../actions/order/type';
import { SET_DELIVERY_ADDRESS, SET_ADDRESS_ID, SET_TAX_ADDRESS, SET_TAX_ID } from '../actions/address/type';
import _ from 'lodash'

const initState = { items: [], blogger_cart: [], count: 0, total: 0, discount: 0, net_total: 0, promo_code: '', discount_err: '', delivery_address: null, new_address: false, tax_address: null, tax_new_address: false, createOrderResult: null, so_no: null, so_header: null, updatePaymentResult: null, updatePaymentErr: null, payCreditCardResult: null, cart_items: null, created_order: null, free_items: null, qrPaid: false, discount_promo: null, discount_promo_detail: [], promo_valid: null, free_item_popup: false, main_item: {} };
/*
    items: [
        {mat_var_id: 0, name: '', img: '', unit_price: 0, qty: 0, buy_from: user_id, review_id: review_id, review_item: review_item}
    ]
*/
export default function (state = initState, action) {
    switch (action.type) {
        case ADD_TO_CART: {
            const addToIndex = action.payload.addToIndex ? action.payload.addToIndex : null;
            const review_id = action.payload.review_id ? action.payload.review_id : null;
            var newItems = state.items;
            if (Array.isArray(action.payload.item)) {
                const addingItems = action.payload.item;
                _.each(addingItems, (i) => {
                    const cleanedItem = _.omit(i, ["image_2", "image_3", "image_4", "image_5", "benefits", "mat_desc", "mat_ingredients", "relate_products", "promotion", "variants"]);
                    newItems = addItemToCart(newItems, cleanedItem, action.payload.qty, addToIndex, review_id);
                });
            } else {
                const newItem = JSON.parse(JSON.stringify(action.payload.item));
                delete newItem.image_2;
                delete newItem.image_3;
                delete newItem.image_4;
                delete newItem.image_5;
                delete newItem.benefits;
                delete newItem.mat_desc;
                delete newItem.mat_ingredients;
                delete newItem.relate_products;
                delete newItem.promotion;
                delete newItem.variants;
                newItems = addItemToCart(state.items, newItem, action.payload.qty, addToIndex, review_id);
            }
            return { ...state, items: newItems, count: countItems(newItems) };

            // const bloggerItems = addItemToBloggerCart(state.blogger_cart, newItem, action.payload.qty, addToIndex);
            // const newTotal = calculateTotal(newItems);
            // localStorage.setItem("cart", JSON.stringify(newItems));

            // return {...state, items: newItems, count: countItems(newItems), blogger_cart : bloggerItems};
        }
        case GET_CART: {
            const toUpdateState = { ...state, items: action.payload.items, count: countItems(action.payload.items) }
            if (action.payload.blogger_cart) {
                toUpdateState.blogger_cart = action.payload.blogger_cart
            }
            return toUpdateState
        }
        case REMOVE_FROM_CART: {
            const newItems = removeItemFromCart(state.items, action.payload);
            // const newTotal = calculateTotal(newItems);
            // localStorage.setItem("cart", JSON.stringify(newItems));
            return { ...state, items: newItems, count: countItems(newItems) };
        }
        case DELETE_FROM_CART: {
            const newItems = deleteItemFromCart(state.items, action.payload);
            // localStorage.setItem("cart", JSON.stringify(newItems));
            return { ...state, items: newItems, count: countItems(newItems) };
        }
        case UPDATE_CART: {
            const newItems = checkItems(action.payload);
            const bloggerItems = checkItems(action.payload)
            // const newTotal = calculateTotal(newItems);
            // localStorage.setItem("cart", JSON.stringify(newItems));
            return { ...state, items: newItems, count: countItems(newItems), blogger_cart: bloggerItems };
        }
        case CHANGE_QTY: {
            const newItems = changeCartQty(state.items, action.payload.item, action.payload.newQty);
            // const newTotal = calculateTotal(newItems);
            // localStorage.setItem("cart", JSON.stringify(newItems));
            return { ...state, items: newItems, count: countItems(newItems) };
        }
        case CART_PROCESS: {
            const free_items = action.payload.free_item;
            const summary = action.payload.summary;
            const cart_items = action.payload.cart;
            // return {...state, cart_summary: summary, total: summary.total, subtotal: summary.subtotal, delivery_cost: summary.delivery_cost, discount: summary.discount, cart_items: cart_items, free_items: free_items};
            // -------------HOME---------------
            return { ...state, count: countItems(cart_items), cart_summary: summary, total: summary.total, subtotal: summary.subtotal, delivery_cost: summary.delivery_cost, delivery_default: summary.delivery_default, discount: summary.discount, discount_promo: summary.discount_promo, discount_promo_detail: summary.discount_promo_detail, cart_items: cart_items, free_items: free_items };
        }
        case CHECK_PROMOTION: {
            return { ...state, discount: action.payload };
        }
        case CHECK_PROMOTION_ERR: {
            return { ...state, discount_err: action.payload };
        }
        case ADD_PROMO_CODE: {
            return { ...state, promo_code: action.payload };
        }
        case SET_DELIVERY_ADDRESS:
            return { ...state, delivery_address: action.payload, new_address: false };
        case SET_ADDRESS_ID:
            // const newAddress = JSON.parse(JSON.stringify(state.delivery_address));
            return { ...state, delivery_address: action.payload, new_address: true };
        case SET_TAX_ADDRESS:
            return { ...state, tax_address: action.payload, tax_new_address: false };
        case SET_TAX_ID:
            // const newAddress = JSON.parse(JSON.stringify(state.delivery_address));
            return { ...state, tax_address: action.payload, tax_new_address: true };
        case CREATE_ORDER:
            // console.log ("reducer: ", action.payload);
            if (action.payload === null) {
                return { ...state, createOrderResult: null, created_order: null };
            } else {
                // console.log (action.payload);
                if (action.payload.error) {
                    return { ...state, createOrderResult: { error: true, message: action.payload.message } };
                } else {
                    // let {so_no, net_price, payment_method, email, response_code, qr_image, expired, qr_id, authen_url} = action.payload;
                    // const created_order = {
                    //     so_no, net_price, payment_method, email, response_code, qr_image, expired, qr_id, authen_url
                    // }
                    return { ...state, createOrderResult: action.payload, created_order: action.payload };
                }

            }
        case CREATE_ORDER_CHAT:
            // console.log ("reducer: ", action.payload);
            if (action.payload === null) {
                return { ...state, createOrderChatResult: null, created_order_chat: null };
            } else {
                // console.log (action.payload);
                if (action.payload.error) {
                    return { ...state, createOrderChatResult: { error: true, message: action.payload.message } };
                } else {
                    // let {so_no, net_price, payment_method, email, response_code, qr_image, expired, qr_id, authen_url} = action.payload;
                    // const created_order = {
                    //     so_no, net_price, payment_method, email, response_code, qr_image, expired, qr_id, authen_url
                    // }
                    return { ...state, createOrderChatResult: action.payload, created_order_chat: action.payload };
                }

            }
        case UPDATE_PAYMENT:
            return { ...state, updatePaymentResult: action.payload };
        case UPDATE_PAYMENT_ERR:
            return { ...state, updatePaymentErr: action.payload };
        case PAY_CREDITCARD:
            return { ...state, payCreditCardResult: action.payload };
        case GET_ORDER_RESPONSE:
            // const created_order = action.payload;
            // console.log (created_order);
            // if (created_order.payment_method === "qr") {
            //     console.log (created_order.qr_id);
            // }
            const temp = action.payload
            if (temp) {
                temp.detail = temp ? (temp.detail ? JSON.parse(temp.detail) : null) : null
            }
            return { ...state, created_order: temp };
        case GET_ORDER_RESPONSE_ERR:
            return { ...state, created_order_err: action.payload, created_order: null };
        case GET_QR:
            let newCreatedOrder = JSON.parse(JSON.stringify(state.created_order));
            const { qr_image, qr_id, expired } = action.payload;
            if (!newCreatedOrder) {
                newCreatedOrder = {};
            }
            newCreatedOrder.qr_image = qr_image;
            newCreatedOrder.expired = expired;
            newCreatedOrder.qr_id = qr_id;
            return { ...state, created_order: newCreatedOrder };
        case GET_CHARGE_STATUS:
            return { ...state, qrPaid: action.payload };
        case GET_PRO_ERR:
            return { ...state, promo_valid: action.payload }
        case CLEAR_COUPON_CODE:
            return { ...state, discount_promo: null, discount_promo_detail: undefined, promo_valid: null }
        case CLEAR_COUPON_ERR_MSG:
            return { ...state, promo_valid: null }
        case DISPLAY_FREE_ITEM_POPUP:
            return { ...state, free_item_popup: action.payload.display, main_item: action.payload.item }
        case ADD_TO_BLOGGER_CART: {
            const addToIndex = action.payload.addToIndex ? action.payload.addToIndex : null;
            // const review_id = action.payload.review_id? action.payload.review_id: null;
            const newItem = JSON.parse(JSON.stringify(action.payload.item));
            delete newItem.image_2;
            delete newItem.image_3;
            delete newItem.image_4;
            delete newItem.image_5;
            delete newItem.benefits;
            delete newItem.mat_desc;
            delete newItem.mat_ingredients;
            delete newItem.relate_products;
            delete newItem.promotion;
            delete newItem.variants;
            const bloggerItems = addItemToBloggerCart(state.blogger_cart, newItem, action.payload.qty, addToIndex);
            return { ...state, blogger_cart: bloggerItems };
        }
        case CHANGE_BLOGGER_CART_QTY: {
            const bloggerItems = changeBloggerCartQty(state.blogger_cart, action.payload.item, action.payload.newQty);
            return { ...state, blogger_cart: bloggerItems };
        }
        case DELETE_FROM_BLOGGER_CART: {
            const bloggerItems = deleteItemFromBloggerCart(state.blogger_cart, state.items[action.payload].mat_var_id);
            // localStorage.setItem("cart", JSON.stringify(newItems));
            return { ...state, blogger_cart: bloggerItems };
        }
        default:
            return { ...state };
    }
}

function addItemToCart(oldItems, itemToAdd, qtyToAdd, addToIndex = null, review_id = null) {
    let items = JSON.parse(JSON.stringify(oldItems));

    if (Array.isArray(itemToAdd)) {
        itemToAdd.forEach((newItem, index) => {
            // console.log (items);
            // console.log ("forEach: ", newItem);
            if (review_id) {
                newItem.review_id = review_id;
            }
            items = addItem(items, newItem, qtyToAdd, addToIndex);
        })
    } else {
        if (review_id) {
            itemToAdd.review_id = review_id;
        }
        items = addItem(items, itemToAdd, qtyToAdd, addToIndex);
    }
    return items;
}

function addItem(oldItems, itemToAdd, qtyToAdd, addToIndex) {
    let items = JSON.parse(JSON.stringify(oldItems));
    const index = items.findIndex((item) => {
        return item.mat_var_id === itemToAdd.mat_var_id;
    });
    if (index === -1) {
        itemToAdd.quantity = qtyToAdd < 1 ? 1 : (qtyToAdd > itemToAdd.limit ? itemToAdd.limit : qtyToAdd);
        if (addToIndex) {
            items.splice(addToIndex, 0, itemToAdd);
        } else {
            items.push(itemToAdd);
        }
    } else {
        items[index].quantity += qtyToAdd;
        items[index].quantity = items[index].quantity < 1 ? 1 : (items[index].quantity > items[index].limit ? items[index].limit : items[index].quantity);
    }
    // console.log (items);
    return items;
}

function changeCartQty(oldItems, item, newQty) {
    let items = JSON.parse(JSON.stringify(oldItems));
    if (Array.isArray(item)) {
        item.forEach((newItem, index) => {
            // console.log (items);
            // console.log ("forEach: ", newItem);
            items = updateItem(items, newItem, newQty);
        })
    } else {
        items = updateItem(items, item, newQty);
    }
    return items;
}

function updateItem(oldItems, itemToUpdate, newQty) {
    let items = JSON.parse(JSON.stringify(oldItems));
    const index = items.findIndex((item) => {
        return item.mat_var_id === itemToUpdate.mat_var_id;
    });
    if (index !== -1) {
        items[index].quantity = newQty < 1 ? 1 : (newQty > itemToUpdate.limit ? itemToUpdate.limit : newQty);
    }
    // console.log (items);
    return items;
}

function countItems(items) {
    let n = items.reduce((p, c) => {
        return p + c.quantity;
    }, 0)

    return n;
}

function removeItemFromCart(oldItems, index) {
    let items = JSON.parse(JSON.stringify(oldItems));

    if (index !== -1) {
        items[index].quantity -= 1;
        if (items[index].quantity <= 0) {
            items.splice(index, 1);
        }
    }

    return items;
}

function deleteItemFromCart(oldItems, index) {
    let items = JSON.parse(JSON.stringify(oldItems));
    items.splice(index, 1);
    return items;
}

function checkItems(oldItems) {
    let items = JSON.parse(JSON.stringify(oldItems));

    const newItems = items.filter((item, index) => {
        return item.quantity > 0;
    });

    return newItems;
}

//Affiliate
function addItemToBloggerCart(oldItems, itemToAdd, qtyToAdd, addToIndex) {
    let items = JSON.parse(JSON.stringify(oldItems));
    let pickedItemToAdd = _.pick(itemToAdd, ['mat_var_id', 'quantity', 'buy_from', 'review_id'])
    if (itemToAdd.buy_from || itemToAdd.review_id) {
        const index = _.findIndex(items, (item) => {
            return item.mat_var_id === itemToAdd.mat_var_id && item.buy_from === itemToAdd.buy_from && item.review_id === itemToAdd.review_id;
        })
        if (index === -1) {
            pickedItemToAdd.quantity = qtyToAdd < 1 ? 1 : (qtyToAdd > 99 ? 99 : qtyToAdd);
            if (addToIndex) {
                items.splice(addToIndex, 0, pickedItemToAdd);
            } else {
                items.push(pickedItemToAdd);
            }
        } else {
            items[index].quantity += qtyToAdd;
            items[index].quantity = items[index].quantity < 1 ? 1 : (items[index].quantity > 99 ? 99 : items[index].quantity);
        }
    }
    // console.log (items);
    return items
}

function changeBloggerCartQty(oldItems, item, newQty) {
    let items = JSON.parse(JSON.stringify(oldItems));
    if (Array.isArray(item)) {
        item.forEach((newItem, index) => {
            // console.log (items);
            // console.log ("forEach: ", newItem);
            items = updateBloggerItem(items, newItem, newQty);
        })
    } else {
        items = updateBloggerItem(items, item, newQty);
    }
    return items;
}

function updateBloggerItem(oldItems, itemToUpdate, newQty) {
    let items = JSON.parse(JSON.stringify(oldItems));
    let sumQty = _.sumBy(items, 'quantity')
    let index = -1
    let check = _.countBy(items, 'mat_var_id')
    let removeCount = sumQty - newQty
    if (check[itemToUpdate.mat_var_id] > 1) {
        if (newQty >= sumQty) {
            index = _.findLastIndex(items, (item) => {
                return item.mat_var_id === itemToUpdate.mat_var_id;
            })
            if (index !== -1) {
                // items[index].quantity = newQty < 1? 1: (newQty > 99? 99: newQty);
                items[index].quantity = (newQty - (sumQty - items[index].quantity))
            }
        } else {
            while (removeCount > 0) {
                index = _.findLastIndex(items, (item) => {
                    return item.mat_var_id === itemToUpdate.mat_var_id;
                })
                if (index !== -1) {
                    // items[index].quantity = newQty < 1? 1: (newQty > 99? 99: newQty);
                    if ((items[index].quantity - removeCount) <= 0) {
                        removeCount -= items[index].quantity
                        items.splice(index, 1)
                    } else {
                        items[index].quantity -= removeCount;
                        removeCount -= items[index].quantity
                    }
                } else {
                    removeCount = 0
                }
            }
        }
    } else {
        index = items.findIndex((item) => {
            return item.mat_var_id === itemToUpdate.mat_var_id;
        });
        if (index !== -1) {
            items[index].quantity = newQty < 1 ? 1 : (newQty > 99 ? 99 : newQty);
        }
    }

    return items;
}

function deleteItemFromBloggerCart(oldItems, matVarId) {
    let items = JSON.parse(JSON.stringify(oldItems));
    items = _.reject(items, (item) => {
        return item.mat_var_id === matVarId
    })
    return items;
}

// function calculateTotal(items) {
//     const sum = items.reduce((a, b) => {
//         let bPrice = b.mat_price;
//         if (b.discountPercent) {
//             bPrice = Math.ceil(bPrice * (1 - b.discountPercent / 100));
//         } 
//         bPrice = bPrice * b.qty;
//         return a + bPrice; // b.qty * b.unit_price;
//     }, 0);

//     return sum;
// }